import { useDispatch } from 'react-redux';

import LoginImage from '../assets/login-image.webp';
import LoginInput from '../components/LoginInput';
import { asyncSetAuthUser } from '../states/auth/actions';

const LoginPage = () => {
  const dispatch = useDispatch();

  const onLogin = ({ email, password }) => {
    dispatch(asyncSetAuthUser({ email, password }));
  };

  return (
    <>
      <div className="hidden md:block bg-cover bg-center" style={{ backgroundImage: `url(${LoginImage})` }} />
      <div className="grid gap-5 pb-24 px-6 py-10 xl:px-[40px] md:pb-[40px] custom-min-height content-center">
        <h1 className="font-black text-2xl tracking-wider text-black">We’ve missed you!</h1>
        <p className="font-light text-black text-lg tracking-wider">More than 150 threads are waiting for your vote and wise suggestions!</p>
        <LoginInput login={onLogin} />
      </div>
    </>
  );
};
export default LoginPage;
